/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

export const getStallListData = state =>
  state && state.list && state.list.items ? state.list.items : [];
export const getStallListFilter = state =>
  state && state.list && state.list.filter ? state.list.filter : null;
export const getStallListPagination = state =>
  state && state.list && state.list.pagination ? state.list.pagination : null;
export const getCategoryFilterIDs = state =>
  state && state.list && state.list.categoryFilter
    ? state.list.categoryFilter
    : null;
export const getStallListLoading = state =>
  state && state.list && state.list.loading ? state.list.loading : false;
export const getStallHideLoading = state =>
  state && state.hideLoading ? state.hideLoading : false;
export const getStallDetailItem = (state, stallID) =>
  state && state.stallDetails && state.stallDetails[stallID]
    ? state.stallDetails[stallID]
    : null;
export const getStallDetailLoading = state =>
  state && state.stallDetailLoading ? state.stallDetailLoading : false;
export const getSelectedFilterData = (state, stallID) =>
  state && state.stallFilterData && state.stallFilterData[stallID]
    ? state.stallFilterData[stallID]
    : null;
export const getStallListFilterData = state =>
  state && state.list && state.list.filterData ? state.list.filterData : null;
export const getStallListFilterFoodTag = state =>
  state &&
  state.list &&
  state.list.filterData &&
  state.list.filterData.tag &&
  state.list.filterData.tag.foodTag
    ? state.list.filterData.tag.foodTag.map(item => item.id)
    : null;
export const getStallListFilterMinPrice = state =>
  state &&
  state.list &&
  state.list.filterData &&
  state.list.filterData.price &&
  state.list.filterData.price.minPrice
    ? state.list.filterData.price.minPrice
    : null;
export const getStallListFilterMaxPrice = state =>
  state &&
  state.list &&
  state.list.filterData &&
  state.list.filterData.price &&
  state.list.filterData.price.maxPrice
    ? state.list.filterData.price.maxPrice
    : null;
export const getStallListFilterMaxEta = state =>
  state &&
  state.list &&
  state.list.filterData &&
  state.list.filterData.eta &&
  state.list.filterData.eta.maxMinutes &&
  state.list.filterData.eta.maxMinutes.etaValue
    ? state.list.filterData.eta.maxMinutes.etaValue
    : null;
export const getStallFilterFoodTagWithID = (state, stallID) =>
  state &&
  state.stallFilterData &&
  state.stallFilterData[stallID] &&
  state.stallFilterData[stallID].foodTag
    ? state.stallFilterData[stallID].foodTag.map(item => item.id)
    : null;
export const getStallFilterMinPrice = (state, stallID) =>
  state &&
  state.stallFilterData &&
  state.stallFilterData[stallID] &&
  state.stallFilterData[stallID].price &&
  state.stallFilterData[stallID].price.minPrice
    ? state.stallFilterData[stallID].price.minPrice
    : null;
export const getStallFilterMaxPrice = (state, stallID) =>
  state &&
  state.stallFilterData &&
  state.stallFilterData[stallID] &&
  state.stallFilterData[stallID].price &&
  state.stallFilterData[stallID].price.maxPrice
    ? state.stallFilterData[stallID].price.maxPrice
    : null;
export const getStallFilterMaxEta = (state, stallID) =>
  state &&
  state.stallFilterData &&
  state.stallFilterData[stallID] &&
  state.stallFilterData[stallID].eta &&
  state.stallFilterData[stallID].eta.maxMinutes &&
  state.stallFilterData[stallID].eta.maxMinutes.etaValue
    ? state.stallFilterData[stallID].eta.maxMinutes.etaValue
    : null;

// stall -> item
export const getStallItemCode = stall =>
  stall && stall.code ? stall.code : null;
export const getStallItemDescription = stall =>
  stall && stall.description ? stall.description : null;
export const getStallItemEstimateWaitTime = stall =>
  stall && stall.estimate_wait_time ? stall.estimate_wait_time : null;
export const getStallItemID = stall => (stall && stall.id ? stall.id : null);
export const getStallItemImageSrc = stall =>
  stall && stall.image && stall.image.banner && stall.image.banner.src
    ? stall.image.banner.src
    : null;
export const getStallItemName = stall =>
  stall && stall.name ? stall.name : null;
export const getStallItemTag = stall =>
  stall && stall.tags ? stall.tags : null;
export const getStallItemCategory = stall =>
  stall && stall.category ? stall.category : null;
export const getStallItemReviewCount = stall =>
  stall && stall.review && stall.review.count ? stall.review.count : 0;
export const getStallItemReviewRating = stall =>
  stall && stall.review && stall.review.rating ? stall.review.rating : 0;
export const getStallItemFilter = stall =>
  stall && stall.filter ? stall.filter : null;
export const getStallIsAvailable = stall =>
  stall && stall.attribute && stall.attribute.is_available
    ? stall.attribute.is_available
    : false;

// stallItem -> filter
export const getStallItemFilterPriceRangeMin = filter =>
  filter && filter.price && filter.price.range && filter.price.range.min
    ? filter.price.range.min
    : null;
export const getStallItemFilterPriceRangeMax = filter =>
  filter && filter.price && filter.price.range && filter.price.range.max
    ? filter.price.range.max
    : null;
export const getStallItemFilterPriceStep = filter =>
  filter && filter.price && filter.price.step ? filter.price.step : null;
export const getStallItemFilterEtaMinuteMax = filter =>
  filter && filter.eta && filter.eta.minute && filter.eta.minute.max
    ? filter.eta.minute.max
    : null;
export const getStallItemFilterTagItems = filter =>
  filter && filter.tag && filter.tag.items ? filter.tag.items : [];



// WEBPACK FOOTER //
// ./src/selectors/stall.js